
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid, Typography, TextField, styled, Select, Box, FormControlLabel } from '@mui/material';
import { CommonButton, CustomCalendarTodayOutlinedIcon, CustomCheckbox, CustomDatePicker, CustomDownIcon, CustomInputLabel, CustomRequiredInputLabel, CustomTimeOutlinedIcon, CustomTimePicker, CustomUpIcon, StyledDateContainer } from '../common/StyledComponents/StyledFields';
import styles from '../contactUs/contactus.module.scss';
import { useState } from 'react';
import { object, string, ValidationError } from 'yup';
import { isEmpty } from 'lodash';
import {
  LocalizationProvider,
  PickerChangeHandlerContext,
  TimeValidationError,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import InputAdornment from "@mui/material/InputAdornment";
import dayjs from "dayjs";

const CustomTextFeild = styled(TextField)`
//  margin-bottom:16px;
& div {
    border-radius: 8px;
}
& input {
    background-color: #fff;
    width: 370px;
    padding: 14px 16px;
    border-radius: 8px;
    height: 20px;  
   
 }
 & fieldset {
    border-style: unset;
 }
`;

const CustomSelect = styled(Select)`
& svg {
    color: #F05802;
 }
 & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff;
    min-width: 0 !important;
 }
 & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
 }
 & fieldset {
    border-style: unset;
 }
`;

interface ErrorMessageTypes {
  pooja: string;
  poojaDateFrom: string;
  poojaTimeFrom: string;
  poojaDateTo: string;
  poojaTimeTo: string;
  deities: string;
}

const DevoteeSponsorshipReport = () => {
  const [isAccordionExpanded, setAccordionExpanded] = useState(false);
  const [donationCartItems, setDonationCartItems] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    pooja: '',
    poojaDateFrom: '',
    poojaTimeFrom: '',
    poojaDateTo: '',
    poojaTimeTo: '',
    deities: '',
  });

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    pooja: '',
    poojaDateFrom: '',
    poojaTimeFrom: '',
    poojaDateTo: '',
    poojaTimeTo: '',
    deities: '',

  });
  const validationSchema = object().shape({
    pooja: string().required('Pooja Name is required'),
    poojaDateFrom: string().required('Pooja Start Date is required'),
    poojaTimeFrom: string().required('Pooja Start Time is required'),
    poojaDateTo: string().required('Phone End Date is required'),
    poojaTimeTo: string().required('Pooja End Time is required'),
    deities: string().required('Deitie is required'),

  });

  const poojaList = [
    {
      label: "Shiva",
    },
    {
      label: "Ganesha (Ganapathi)",
    },
    {
      label: "Load Narasimha",
    },
    {
      label: "Sri Rama",
    },
    {
      label: "Ayyappa",
    },
    {
      label: "Parvathi",
    },
  ];

  const handleSave = async (): Promise<any> => {

    const errors: ErrorMessageTypes = {
      pooja: '',
      poojaDateFrom: '',
      poojaTimeFrom: '',
      poojaDateTo: '',
      poojaTimeTo: '',
      deities: '',

    };

    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      alert('Registration Successful');

      // Call your API or perform other actions here
      //  saveApiCall();

    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const handleAccordionChange = () => {
    setAccordionExpanded((prevExpanded) => !prevExpanded);
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleCheckboxChange = (label: string) => {
    const isSelected = donationCartItems.includes(label);

    if (isSelected) {
      setDonationCartItems(donationCartItems.filter((item) => item !== label));
    } else {
      setDonationCartItems([...donationCartItems, label]);
    }
  };

  const handleDateChange = (field: keyof ErrorMessageTypes, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM-DD-YYYY")
        : "",
    });
  };


  const deities = () => {
    return (
      <div>
        {CustomRequiredInputLabel("Deities", true)}
        <div className={styles.deitiesContainer}>
          {poojaList.map((item, index) => (
            <Box key={index} className={styles.singleBox}>
              <Box sx={{ display: "flex", alignItems: "center" }} className={styles.checkTitle}>
                <FormControlLabel
                  control={
                    <CustomCheckbox
                      size="medium"
                      className={styles.checkbox}
                      checked={donationCartItems.includes(item.label)}
                      onChange={() => handleCheckboxChange(item.label)}
                    />
                  }
                  label=""
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: "-4px",
                  }}
                  className={styles.textradio}
                >
                  <Typography className={styles.textStyles}>
                    {item.label}
                  </Typography>
                  {/* {radioButtons()} */}
                </Box>
              </Box>
            </Box>
          ))}
        </div>
      </div>
    );
  };


  const poojaStartDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.poojaDateFrom
                    ? dayjs(formData.poojaDateFrom, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, poojaDateFrom: "" });
                  handleDateChange("poojaDateFrom", value);
                }}
                className={
                  errorMessage.poojaDateFrom
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.poojaDateFrom ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.poojaDateFrom}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const poojaStartTimePicker = (): React.ReactElement => {
    return (
      <StyledDateContainer
        sx={{ backgroundColor: "#fff", borderRadius: "8px", height: "48px" }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateTimePicker"]}>
            <CustomTimePicker
              slots={{
                openPickerIcon: CustomTimeOutlinedIcon,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
              }}
              views={["hours", "minutes"]}
              format="HH:mm A"
              value={
                formData.poojaTimeFrom
                  ? dayjs(formData.poojaTimeFrom, "HH:mm")
                  : ""
              }
              onChange={(
                value: any,
                _context: PickerChangeHandlerContext<TimeValidationError>
              ) => {
                handleFieldChange("poojaTimeFrom", value.format("HH:mm"));
                setErrorMessage({ ...errorMessage, poojaTimeFrom: "" });
              }}
              className={
                errorMessage.poojaTimeFrom
                  ? styles.errorTextField
                  : styles.textField
              }
            />
          </DemoContainer>
        </LocalizationProvider>
        {errorMessage.poojaTimeFrom ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.poojaTimeFrom}
          </Typography>
        ) : (
          ""
        )}
      </StyledDateContainer>
    );
  };

  const poojaEndDatePicker = (): React.ReactElement => {
    return (
      <div style={{ minWidth: "100%", borderRadius: "8px" }}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.poojaDateTo
                    ? dayjs(formData.poojaDateTo, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, poojaDateTo: "" });
                  handleDateChange("poojaDateTo", value);
                }}
                className={
                  errorMessage.poojaDateTo
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.poojaDateTo ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.poojaDateTo}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  const poojaEndTimePicker = (): React.ReactElement => {
    return (
      <StyledDateContainer
        sx={{ backgroundColor: "#fff", borderRadius: "8px", height: "48px" }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateTimePicker"]}>
            <CustomTimePicker
              slots={{
                openPickerIcon: CustomTimeOutlinedIcon,
              }}
              slotProps={{
                inputAdornment: {
                  position: "end",
                },
              }}
              views={["hours", "minutes"]}
              format="HH:mm A"
              value={
                formData.poojaTimeTo
                  ? dayjs(formData.poojaTimeTo, "HH:mm")
                  : ""
              }
              onChange={(
                value: any,
                _context: PickerChangeHandlerContext<TimeValidationError>
              ) => {
                handleFieldChange("poojaTimeTo", value.format("HH:mm"));
                setErrorMessage({ ...errorMessage, poojaTimeTo: "" });
              }}
              className={
                errorMessage.poojaTimeTo
                  ? styles.errorTextField
                  : styles.textField
              }
            />
          </DemoContainer>
        </LocalizationProvider>
        {errorMessage.poojaTimeTo ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.poojaTimeTo}
          </Typography>
        ) : (
          ""
        )}
      </StyledDateContainer>
    );
  };


  return (
    <div>
      <div className={styles.faqtotalLayout}>
        <Typography className={styles.typoGraphyHeader}>
          Devotee Sponsorship Report
        </Typography>
        <Card className={styles.cardContainer}>
          <div className={styles.formFields}>
            <Accordion
              sx={{
                border: isAccordionExpanded ? '1px solid rgba(136, 46, 20, 0.40)' : '',
                background: '#FFF9E4',
                boxShadow: "none", borderRadius: "8px"
              }}
              expanded={isAccordionExpanded}
              onChange={handleAccordionChange}
            >
              <AccordionSummary
                aria-controls={`panel-content`}
                id={`panel--header`}
              >
                <Grid container>
                  <Grid item className={styles.iconstyles}>
                    {isAccordionExpanded ? (
                      <CustomUpIcon />
                    ) : (
                      <CustomDownIcon />
                    )}
                  </Grid>
                  <Grid item>
                    <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Abihshekam Report</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid>
                  <Grid container spacing={2}>
                    <Grid xs={12} sm={3} item>
                      {CustomRequiredInputLabel("Pooja", true)}
                      <CustomTextFeild
                        fullWidth
                        required
                        value={formData.pooja}
                        onChange={(e) => {
                          setErrorMessage({ ...errorMessage, pooja: '' });
                          handleFieldChange('firstName', e.target.value);
                        }}
                        className={!isEmpty(errorMessage.pooja) ? styles.errorTextField : ""}
                      />
                      {!isEmpty(errorMessage.pooja) && <Typography sx={{ color: "red", fontSize: "12px" }}>{errorMessage.pooja}</Typography>}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid xs={12} sm={3} item>
                      {CustomRequiredInputLabel("Pooja Date From", true)}
                     {poojaStartDatePicker()}
                    </Grid>
                    <Grid xs={12} sm={3} item>
                      {CustomRequiredInputLabel("Pooja Time From", true)}
                      {poojaStartTimePicker()}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{marginTop: "10px"}}>
                    <Grid xs={12} sm={3} item>
                      {CustomRequiredInputLabel("Pooja Date To", true)}
                      {poojaEndDatePicker()}
                    </Grid>
                    <Grid xs={12} sm={3} item>
                      {CustomRequiredInputLabel("Pooja Time To", true)}
                      {poojaEndTimePicker()}
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} sx={{marginTop: "10px"}}>
                    <Grid xs={12} item>
                      {deities()}
                    </Grid>
                  </Grid>
                </Grid>
                <CommonButton onClick={handleSave}>Submit</CommonButton>
              </AccordionDetails>
            </Accordion>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default DevoteeSponsorshipReport